<template>
  <path
    fill="currentColor"
    d="M13.146 11.0498L12.9717 9.05746L15.3463 8.84971C14.4472 7.98316 13.2243 7.45024 11.877 7.45024C9.11553 7.45024 6.87695 9.68881 6.87695 12.4502C6.87695 15.2117 9.11553 17.4502 11.877 17.4502C13.6977 17.4502 15.2912 16.477 16.1655 15.0224L18.1682 15.5231C17.0302 17.8487 14.6406 19.4502 11.877 19.4502C8.01096 19.4502 4.87695 16.3162 4.87695 12.4502C4.87695 8.58424 8.01096 5.45024 11.877 5.45024C13.8234 5.45024 15.5843 6.24468 16.8531 7.527L16.6078 4.72406L18.6002 4.54974L19.1232 10.5269L13.146 11.0498Z"
  />
</template>
